import React, { useState, useEffect } from "react";
import { AllSensorsDataContext } from "./context";

import { getAllSensorsData } from "../services/services";

const AllSensorsProvider = ({ children }) => {
  const [allSensorsData, setAllSensorsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllSensors = async () => {
      const AllSensors = await getAllSensorsData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
          return [];
        });

      const tempAllSensors = {};

      for (let sensor of AllSensors) {
        if (tempAllSensors[sensor.sensortype_id] === undefined) {
          tempAllSensors[sensor.sensortype_id] = { data: [], filters: [] };
          // tempAllSensors[sensor.sensortype_id] = [];
        }
        tempAllSensors[sensor.sensortype_id].data.push(sensor);
      }

      // const allSensorsTypes = Object.keys(tempAllSensors);

      // for (let type of allSensorsTypes) {
      //   // if (type === "31") {
      //   //   tempAllSensors[31].filters.push(
      //   //     {
      //   //       title: "Πινακίδες σε λειτουργία",
      //   //       isActive: false,
      //   //       id: 0,
      //   //     },
      //   //     {
      //   //       title: "Πινακίδες εκτός λειτουργίας",
      //   //       isActive: false,
      //   //       id: 1,
      //   //     }
      //   //   );
      //   // }
      // }

      tempAllSensors["31"]?.data.sort(
        (a, b) =>
          parseInt(a.mysensor_name.substring(22)) -
          parseInt(b.mysensor_name.substring(22))
      );

      setAllSensorsData(tempAllSensors);
    };

    fetchAllSensors();
  }, []);

  return (
    <AllSensorsDataContext.Provider
      value={{
        allSensorsData,
        setAllSensorsData,
        loading,
        error,
      }}
    >
      {children}
    </AllSensorsDataContext.Provider>
  );
};

export default AllSensorsProvider;
